const camelize = (string: string) =>
  string.replace(/-([a-z])/gi, (s, group) => group.toUpperCase());

// 1ˢᵗ step logic which calls the 2ⁿᵈ step logic
const style2object = (style: string) => {
  if ((typeof style).toLowerCase() === 'string') {
    return style
      .split(';')
      .filter(s => s.length)
      .reduce((a: any, b) => {
        const keyValue: string[] = b.split(':');
        const ret = { ...a };
        const key = camelize(keyValue[0]);
        return { ...ret, [key]: keyValue[1] };
      }, {});
  }
  return style;
};

export default style2object;
